
import React from 'react';
import { 
  FormField, 
  FormItem, 
  FormLabel, 
  FormControl,
  FormMessage
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { FarmFormValues } from './FormSchema';

interface LocationCoordinatesFieldsProps {
  form: UseFormReturn<FarmFormValues>;
}

const LocationCoordinatesFields: React.FC<LocationCoordinatesFieldsProps> = ({ form }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        control={form.control}
        name="latitude"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Latitude (optional)</FormLabel>
            <FormControl>
              <Input 
                type="number" 
                step="0.000001"
                placeholder="e.g. 9.0222"
                {...field}
                value={field.value === null ? '' : field.value}
                onChange={(e) => {
                  const value = e.target.value === '' ? null : parseFloat(e.target.value);
                  field.onChange(value);
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="longitude"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Longitude (optional)</FormLabel>
            <FormControl>
              <Input 
                type="number" 
                step="0.000001"
                placeholder="e.g. 38.7468"
                {...field}
                value={field.value === null ? '' : field.value}
                onChange={(e) => {
                  const value = e.target.value === '' ? null : parseFloat(e.target.value);
                  field.onChange(value);
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default LocationCoordinatesFields;
